import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
// import AnimatedText from 'react-animated-text-content';
import './About.scss';
import { urlFor, client } from '../../client';
import { AppWrap } from '../../wrapper';


// const abouts=[
//   {title: 'Web Devlopment', description: 'I am a good Devloper', imgUrl: images.about01},
//   {title: 'Web Devlopment', description: 'I am a good Devloper', imgUrl: images.about02},
//   {title: 'Web Devlopment', description: 'I am a good Devloper', imgUrl: images.about03},
//   {title: 'Web Devlopment', description: 'I am a good Devloper', imgUrl: images.about04}
// ]

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);
  return (
    <>
      <h2 className="h-text"><i>Hello! I am <span>Yashwant</span>, a CS Engineering Student from <span>Delhi Technological University</span>, Delhi. I am a consistent learner who believes in <span>smart work and exploring many technical skills.</span> I am most attracted to solving real <span>customer problems</span> with a business justification, I am having good hold in <span>computer fundamentals and love to build projects.</span></i></h2>
      <h2 className="head-text hobby">My Hobbies and Interests</h2>
      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(About, 'about');